import { takeLeading } from "redux-saga/effects";
import { post } from "sagas/helpers/network";

function* execute(action: sage.actions.jobs.IDownloadResult) {
    const response = yield post("/get-result", {
        result_id: action.resultId,
    });
    if (response.data !== null) {
        const downloadLink = response.data.download_link;
        const link = document.createElement("a");
        link.download = "frames.zip";
        link.href = downloadLink;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
}

export default function* saga(): Generator {
    yield takeLeading("com.sage.actions.jobs.IDownloadResult", execute);
}
